import { sizes } from '../../const/sizes';
import { cardBackgroundMap, cardShadowMap } from './cardConst';
export const useCardStyle = ({ cardVariant, fullWidth, backgroundColorOverride, borderRadiusOverride, overflow, fullHeight, center, }) => {
    return {
        backgroundColor: backgroundColorOverride ?? cardBackgroundMap[cardVariant],
        boxShadow: cardShadowMap[cardVariant],
        borderRadius: borderRadiusOverride ?? sizes.card.borderRadius,
        width: fullWidth ? '100%' : undefined,
        height: fullHeight ? '100%' : undefined,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: center ? 'center' : undefined,
        alignItems: center ? 'center' : undefined,
        overflow,
    };
};
